// @ts-nocheck



import CommonApi from './../commonApi';
import { convertFromKopToRub, convertFromRubToKop } from '../pure/unitConversions';

const convertDataToServer = (
currentMaintenanceCost) => (
{
  ...currentMaintenanceCost,
  materialExpenseRate: convertFromRubToKop(
    currentMaintenanceCost.materialExpenseRate
  ),
  materialExpenseRateWithCoefficient: convertFromRubToKop(
    currentMaintenanceCost.materialExpenseRateWithCoefficient
  )
});

const convertDataFromServer = (
currentMaintenanceCost) => (
{
  ...currentMaintenanceCost,
  materialExpenseRate: convertFromKopToRub(
    currentMaintenanceCost.materialExpenseRate
  ),
  materialExpenseRateWithCoefficient: convertFromKopToRub(
    currentMaintenanceCost.materialExpenseRateWithCoefficient
  )
});

const currentMaintenanceCost = new CommonApi(
  'currentMaintenanceCost',
  'Стоимость текущего ремонта',
  convertDataToServer,
  convertDataFromServer
);

export default {
  ...currentMaintenanceCost
};
